import { render, staticRenderFns } from "./WelcomeWorkspaceBlurb.vue?vue&type=template&id=4250e153&scoped=true"
var script = {}
import style0 from "./WelcomeWorkspaceBlurb.vue?vue&type=style&index=0&id=4250e153&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4250e153",
  null
  
)

export default component.exports